import { render, staticRenderFns } from "./WaitingToBeFiled.vue?vue&type=template&id=fb563208&scoped=true&"
import script from "./WaitingToBeFiled.vue?vue&type=script&lang=js&"
export * from "./WaitingToBeFiled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb563208",
  null
  
)

export default component.exports